/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Swift_Crane_RestInputs */

const en_deep_swift_crane_rest = /** @type {(inputs: Deep_Swift_Crane_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All attributes`)
};

const de_deep_swift_crane_rest = /** @type {(inputs: Deep_Swift_Crane_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Merkmale`)
};

/**
* | output |
* | --- |
* | "All attributes" |
*
* @param {Deep_Swift_Crane_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_swift_crane_rest = /** @type {((inputs?: Deep_Swift_Crane_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Swift_Crane_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_swift_crane_rest(inputs)
	return de_deep_swift_crane_rest(inputs)
});